<template>
    <aside class="pc-navigation" :aria-label="pcCopy.casino">
        <BrandMark />
        <nav class="pc-nav-main">
            <button v-for="item in links" :key="item.path" type="button" class="pc-nav-link" :class="{ active: isActive(item.path) }" :aria-current="isActive(item.path) ? 'page' : null" @click="navigate(item)">
                <UiIcon :name="item.icon" /><span>{{ item.label }}</span>
            </button>
            <button type="button" class="pc-nav-link" @click="$emit('redeem')"><UiIcon name="gift" /><span>{{ pcCopy.redeem }}</span></button>
            <router-link to="/JoinChannel" class="pc-nav-link" :class="{ active: isActive('/JoinChannel') }"><UiIcon name="share" /><span>{{ pcCopy.social }}</span></router-link>
            <div class="pc-nav-divider"></div>
            <button type="button" class="pc-nav-link" @click="openCollection('Recente')"><UiIcon name="clock" /><span>{{ pcCopy.recent }}</span></button>
            <button type="button" class="pc-nav-link" @click="openCollection('Favoritos')"><UiIcon name="heart" /><span>{{ pcCopy.favorites }}</span></button>
        </nav>
        <div class="pc-nav-bottom">
            <div class="pc-nav-divider"></div>
            <ThemeSkinSelect />
            <language ref="language" :show="true" :showIcon="false">
                <template #langType>
                    <button type="button" class="pc-nav-link" :disabled="DisabledBelongCountry === 'disable'" @click="$refs.language.onShowLangPopup()"><UiIcon name="globe" /><span>{{ languageName }}</span><UiIcon class="language-chevron" name="chevron" /></button>
                </template>
            </language>
            <button type="button" class="pc-nav-link" @click="$store.dispatch('user/setIsShowDownAppPopup', true)"><UiIcon name="download" /><span>{{ pcCopy.install }}</span></button>
            <router-link to="/notification?type=0" class="pc-nav-link"><UiIcon name="headset" /><span>{{ pcCopy.help }}</span></router-link>
        </div>
    </aside>
</template>

<script>
import UiIcon from './UiIcon.vue'
import BrandMark from './BrandMark.vue'
import language from '@/components/language'
import desktopCopy from './copy'
import ThemeSkinSelect from '@/components/ThemeSkinSelect.vue'
export default {
    components: { UiIcon, BrandMark, language, ThemeSkinSelect },
    mixins: [desktopCopy],
    computed: {
        languageName() { return this.langObj[this.$store.getters.language]?.name || 'English' },
        links() {
            return [
                { path: '/Home', icon: 'game', label: this.pcCopy.casino },
                { path: '/Event', icon: 'gift', label: this.pcCopy.promotion },
                { path: '/vip', icon: 'crown', label: this.pcCopy.vip },
                { path: '/Affiliate', icon: 'people', label: this.pcCopy.affiliate }
            ]
        }
    },
    methods: {
        isActive(path) { return this.$route.path.toLowerCase() === path.toLowerCase() || (path === '/Home' && this.$route.path === '/RU') },
        navigate(item) {
            if (item.path === '/vip') this.onNavToByIsLogin({ url: item.path })
            else this.onNavTo({ url: item.path })
        },
        openCollection(code) {
            const title = code === 'Recente' ? this.pcCopy.recent : this.pcCopy.favorites
            this.onNavToByIsLogin({ url: 'Casino', type: 'post', params: { params: encodeURIComponent(JSON.stringify({ code, title })) } })
        }
    }
}
</script>

<style scoped>
.pc-navigation { height: 100%; display: flex; flex-direction: column; padding: 12px 18px 22px; background: #14161b; border-right: 1px solid #2d3038; text-align: left; }
.pc-nav-main { margin-top: 24px; flex: 1; min-height: 0; overflow-y: auto; }
.pc-nav-link { width: 100%; display: flex; align-items: center; gap: 18px; min-height: 58px; padding: 12px 18px; margin-bottom: 6px; border: 1px solid transparent; border-radius: 10px; background: transparent; color: #c5c6d0; text-align: left; font-size: 16px; line-height: 1.4; cursor: pointer; text-decoration: none; }
.pc-nav-link:hover { color: #f7f6f5; background: #202024; }
.pc-nav-link.active { position: relative; color: #ff6055; background: #332125; border-color: #46282d; }
.pc-nav-link.active::before { content: ''; position: absolute; left: -1px; top: 5px; bottom: 5px; width: 2px; border-radius: 3px; background: #ff6055; }
.pc-nav-link .pc-icon { width: 26px; height: 26px; }
.pc-nav-divider { height: 1px; margin: 26px 5px 16px; background: #34343a; }
.pc-nav-bottom { flex: 0 0 auto; }
.pc-nav-bottom .pc-nav-link { min-height: 48px; margin: 0; font-size: 14px; gap: 16px; padding: 10px 18px; }
.pc-nav-bottom .language-chevron { width: 14px; height: 14px; margin-left: auto; transform: rotate(90deg); }
.pc-nav-link:disabled { opacity: .55; cursor: default; }
@media (max-width: 1199px) { .pc-navigation { padding-inline: 10px; } .pc-nav-link { gap: 12px; font-size: 14px; } }
</style>
